/**
 * @file 物料和效果图在新窗口中预览
 * @author fuqiang15
 */

/**
 * 计算新窗口居中的左上角
 * refers to https://stackoverflow.com/questions/4068373/center-a-popup-window-on-screen
 *
 * @param {number} width 新窗口宽度
 * @param {number} height 新窗口高度
 * @return {Object} 新窗口居中的左上角
 */
export function calcLeftTop(width, height) {
    let dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    let dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

    let windowWidth = window.innerWidth || document.documentElement.clientWidth || screen.width;
    let windowHeight = window.innerHeight || document.documentElement.clientHeight || screen.height;

    let left = ((windowWidth / 2) - (width / 2)) + dualScreenLeft;
    let top = ((windowHeight / 2) - (height / 2)) + dualScreenTop;
    return {left, top};
}
// 返回的 update 方法适用于异步获取 iframe 的 src 和 html 的场景
// 在某些情况下可能需要拿到打开的窗口，返回的 getWindow 方法可以拿到当前打开的窗口
function previewCommon(update, options = {}) {
    let {
        src,
        html,
        width,
        height,
        url
    } = options;
    let {left, top} = calcLeftTop(width, height);
    // 在用户触发的事件中同步打开，这样可以减少浏览器的block
    let w = window.open(url, '_blank', `left=${left},top=${top},width=${width},height=${height}`);
    let realUpdate = options => update(w, options);
    if (src || html) {
        realUpdate();
    }
    return {
        getWindow: () => w,
        update: realUpdate
    };
}


/**
 * 打开新窗口，这样可以在https站开新窗口加载http资源
 *
 * @param {Object} options 新窗口的配置
 * @return {Object} 返回打开结果对象
 */
export function preview(options = {}) {
    let realOptions = {
        width: 320,
        height: 640,
        url: `http://${location.host}/preview.html`,
        ...options
    };
    function update(w, options = {}) {
        let {
            src,
            html,
            width,
            height,
            title = '预览'
        } = {
            ...realOptions,
            ...options
        };
        setTimeout(() => {
            w.postMessage(JSON.stringify({src, html, height, width, title}), `http://${location.host}`);
        }, 1000);
        return w;
    }
    return previewCommon(update, realOptions);
}
